
<span *ngFor="let item of globals.Messages;" >

      
 <div class="alert alert-success alert-dismissible fade show" role="alert" *ngIf="item.type == 3">
   {{item.body}}
   <button type="button" class="close" data-dismiss="alert" aria-label="Close">
    <span aria-hidden="true" style="text-align: center;">&times;</span>
  </button>
  </div>
  <div class="alert alert-danger alert-dismissible fade show" role="alert" *ngIf="item.type == 0">
      {{item.body}}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true" style="text-align: center;">&times;</span>
      </button>
  </div>
  <div class="alert alert-warning alert-dismissible fade show" role="alert" *ngIf="item.type == 1">
      {{item.body}}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true" style="text-align: center;">&times;</span>
      </button>
  </div>
  <div class="alert alert-info alert-dismissible fade show" role="alert" *ngIf="item.type == 2">
      {{item.body}}
      <button type="button" class="close" data-dismiss="alert" aria-label="Close">
        <span aria-hidden="true" style="text-align: center;">&times;</span>
      </button>
  </div>
</span> 



     
    